import { H4 } from "@/lib/styles";

import {
  bigLabelTypographicStyle,
  smallLabelTypographicStyle,
} from "@/lib/styles/helpers";
import styled from "styled-components";
import { CardContainer } from "../styles";

export const CardContainerText = styled(CardContainer)`
  background-color: ${({theme})=> theme.colors.white};
  padding: 24px 0;
  gap: 16px;
  margin: 0 1rem;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const WrapperContent = styled.div`

  & li,
  & p {
    font-family: ${({ theme }) => theme.fontFamilies.secondary};
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 0;
    font-size: 14px;
    line-height: 22px;
  }
`;

export const Title = styled(H4)`
  color: ${({ theme }) => theme.colors.red};
`;

export const Subtitle = styled.p`
  ${bigLabelTypographicStyle}
  color: ${({ theme }) => theme.colors.black};
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap; //? check if needed for long labels
  gap: 8px;
`;

export const Label = styled.p`
  ${smallLabelTypographicStyle}
  color: ${({ theme }) => theme.colors.darkMiddle};
  text-transform: uppercase;
  white-space: nowrap;
`;
export const Time = styled.p`
  ${smallLabelTypographicStyle}
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
  text-transform: uppercase;
`;

export const Url = styled.a`
  ${smallLabelTypographicStyle}
  font-weight: 700;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.red};
`;
